import React from 'react';
import { CalendarCheckIcon, UsersIcon, HouseIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { copy } from '../data/copy';
import { SectionHeading } from './SectionHeading';
import type { Localized } from '../types';
const steps: {
  id: string;
  icon: typeof UsersIcon;
  title: Localized;
  body: Localized;
}[] = [{
  id: 'request',
  icon: CalendarCheckIcon,
  title: {
    en: 'Request Cleaning',
    es: 'Solicite la Limpieza'
  },
  body: {
    en: "Call, text or book online — it's easy and fast, and we confirm your window right away.",
    es: 'Llame, escriba o reserve en línea: es fácil y rápido, y confirmamos su horario de inmediato.'
  }
}, {
  id: 'clean',
  icon: UsersIcon,
  title: {
    en: 'We Arrive & Clean',
    es: 'Llegamos y Limpiamos'
  },
  body: {
    en: 'Our professional team arrives on time with all supplies and works through the full checklist.',
    es: 'Nuestro equipo llega a tiempo con todos los productos y cumple la lista completa.'
  }
}, {
  id: 'enjoy',
  icon: HouseIcon,
  title: {
    en: 'Enjoy Your Clean Home',
    es: 'Disfrute Su Hogar Limpio'
  },
  body: {
    en: 'Come home to a spotless, sparkling house — and tell us if anything needs a second pass.',
    es: 'Regrese a una casa impecable y brillante; avísenos si algo necesita un segundo repaso.'
  }
}];
export function HowItWorks() {
  const {
    t
  } = useLanguage();
  return <section className="bg-navy" data-id="element-234" data-mp="3ae8m2h13g3vc">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-24" data-id="element-235" data-mp="36b3moncb8iax">
        <SectionHeading kicker={t(copy.stepsKicker)} title={t(copy.stepsTitle)} tone="light" data-id="element-236" data-mp="3kabo7mvy42ia" />

        <ol className="relative mt-14 grid grid-cols-1 gap-10 lg:grid-cols-3 lg:gap-8" data-id="element-237" data-mp="3k7z699q6ts58">
          <div className="absolute left-0 right-0 top-7 hidden h-px bg-white/15 lg:block" aria-hidden="true" data-id="element-238" data-mp="3f95xfuluipbe" />
          {steps.map((step, index) => <li key={step.id} className="relative flex flex-col" data-id="element-239" data-mp="1kz260y3ih5fd" data-mpi={index}>
              <div className="flex items-center gap-4" data-id="element-240" data-mp="3l0ihu95jzqrs">
                <span className="relative z-10 flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-bright font-display text-lg font-extrabold text-white ring-8 ring-navy" data-id="element-241" data-mp="3pyk2gyimny5d">
                  {index + 1}
                </span>
                <step.icon className="h-6 w-6 text-aqua" aria-hidden="true" data-id="element-242" data-mp="2ux3mr7tt621" />
              </div>
              <h3 className="mt-6 font-display text-xl font-extrabold text-white" data-id="element-243" data-mp="7rvyjbzbdh1a">
                {t(step.title)}
              </h3>
              <p className="mt-2 max-w-sm text-sm leading-relaxed text-white/70" data-id="element-244" data-mp="cq7abs9661m5">{t(step.body)}</p>
            </li>)}
        </ol>
      </div>
    </section>;
}